import { Skeleton } from '@shigo-ui/ui';
import { DashboardPageFormBody } from '@shigo-ui/dashboard-ui';

import { dashboardT } from '../../../../../lib/messages';

export function LineItemEditorSkeleton() {
  return (
    <DashboardPageFormBody
      className="gap-4"
      role="status"
      aria-label={dashboardT('madBuy.lineItems.loadingLineItem')}
    >
      <Skeleton className="mx-auto h-6 w-40" />
      <Skeleton className="h-9 w-full" />
      <Skeleton className="h-9 w-full" />
      <Skeleton className="h-9 w-full" />
      <Skeleton className="h-32 w-full" />
    </DashboardPageFormBody>
  );
}

export function LineItemEditorErrorState() {
  return (
    <DashboardPageFormBody className="gap-2 py-12 text-center">
      <h2 className="text-foreground text-lg font-semibold">
        {dashboardT('madBuy.lineItems.loadFailed')}
      </h2>
      <p className="text-muted-foreground text-sm">
        {dashboardT('madBuy.lineItems.refreshOrTryAgain')}
      </p>
    </DashboardPageFormBody>
  );
}
